"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toTheme = toTheme;
exports.default = void 0;

var _colorMappings = require("./1_useMappings/colorMappings");

var _shadowMappings = require("./1_useMappings/shadowMappings");

var _borderMappings = require("./1_useMappings/borderMappings");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function toTheme(annotatedTheme) {
  return Object.keys(annotatedTheme).reduce(function (acc, cur) {
    acc[cur] = annotatedTheme[cur].value;
    return acc;
  }, {});
}

var cakeTheme = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
  // the following logo entries provide placeholders and a test case for making sure that the logo is correctly pulled in both with and without and override
  // logo: { value: 'https://teespring-storecontent.s3.amazonaws.com/oH48W9OolEiG3_iE40F0tw_store_banner_image?1478560026161', dataType: 'other' },
  logo: {
    value: '',
    dataType: 'other'
  },
  logoInverse: {
    value: '',
    dataType: 'other'
  }
}, _borderMappings.borderMappings), _colorMappings.colorMappings), _shadowMappings.shadowMappings), {}, {
  // ================================================================================================================ //
  // todo: stuff below here has not been audited/merged with the new design system
  // ================================================================================================================ //
  // new shadows that need to be merged into the shadow system - this may require some rework //
  // todo: merge/consolidate/refactor the shadow system
  s_menu: {
    value: '0 2px 8px rgba(0,136,78,0.25)',
    dataType: 'shadow'
  },
  // ## FONTS ## //
  primaryFont: {
    value: '"Montserrat", sans-serif',
    dataType: 'font'
  },
  secondaryFont: {
    value: '"Nunito", sans-serif',
    dataType: 'font'
  },
  // ## FONT WEIGHTS ## //
  primaryNormal: {
    value: '400',
    dataType: 'weight'
  },
  primaryMedium: {
    value: '500',
    dataType: 'weight'
  },
  primaryHeavy: {
    value: '700',
    dataType: 'weight'
  },
  secondaryNormal: {
    value: '400',
    dataType: 'weight'
  },
  // used for disabled buttons
  secondaryHeavy: {
    value: '800',
    dataType: 'weight'
  },
  // ## FONT SIZES ## //
  fontMinuscule: {
    value: '0.56rem',
    dataType: 'dim'
  },
  // do not use - this belongs in the table only
  fontSmall: {
    value: '0.875rem',
    dataType: 'dim'
  },
  fontMediumSmall: {
    value: '1.15rem',
    dataType: 'dim'
  },
  fontMedium: {
    value: '1.2rem',
    dataType: 'dim'
  },
  fontLarge: {
    value: '1.5rem',
    dataType: 'dim'
  },
  fontHero: {
    value: '2.2rem',
    dataType: 'dim'
  },
  fontInitial: {
    value: '1rem',
    dataType: 'dim'
  },
  // ## ICON SIZES ## //
  iconPadding: {
    value: '.1rem',
    dataType: 'dim'
  },
  iconSmall: {
    value: '.8rem',
    dataType: 'dim'
  },
  iconDefault: {
    value: '1.25rem',
    dataType: 'dim'
  },
  iconLarge: {
    value: '1.8rem',
    dataType: 'dim'
  },
  iconSmallLarge: {
    value: '2.3rem',
    dataType: 'dim'
  },
  iconMediumLarge: {
    value: '2.8rem',
    dataType: 'dim'
  },
  iconExtraLarge: {
    value: '5rem',
    dataType: 'dim'
  },
  // ## LAYERING ## //
  dropDown: {
    value: '1000',
    dataType: 'layer'
  },
  loader: {
    value: '10000',
    dataType: 'layer'
  },
  menu: {
    value: '20000',
    dataType: 'layer'
  },
  modal: {
    value: '30000',
    dataType: 'layer'
  },
  // todo: { value: items above this point should be pretty standard and well thought out
  // ########################################################################### //
  // ########################################################################### //
  // todo: { value: we may want to clean up stuff below here
  // ## DIMENSIONS ## //
  indentMajor: {
    value: '7rem',
    dataType: 'dim'
  },
  indentMinor: {
    value: '1.5rem',
    dataType: 'dim'
  },
  standardPadding: {
    value: '.625rem',
    dataType: 'dim'
  },
  // 10px @16pt
  mobileMenuHeight: {
    value: '4rem',
    dataType: 'dim'
  },
  authorizedMenuHeight: {
    value: '4.375rem',
    dataType: 'dim'
  },
  desktopMenuHeight: {
    value: '6.25rem',
    dataType: 'dim'
  },
  mobileNavHeight: {
    value: '2rem',
    dataType: 'dim'
  },
  progressBarHeight: {
    value: '1.1rem',
    dataType: 'dim'
  },
  miniProgressBarHeight: {
    value: '0.25rem',
    dataType: 'dim'
  },
  footerHeight: {
    value: '4rem',
    dataType: 'dim'
  },
  // #### component sizes #### //
  componentSizeLarge: {
    value: '37.5rem',
    dataType: 'dim'
  },
  // 600px @16pt
  componentSizeMed: {
    value: '18.75rem',
    dataType: 'dim'
  },
  // 300px @16pt
  standardButtonHeight: {
    value: '3rem',
    dataType: 'dim'
  },
  // 48px @16pt
  mediumButtonHeight: {
    value: '2rem',
    dataType: 'dim'
  },
  smallButtonHeight: {
    value: '1.5rem',
    dataType: 'dim'
  },
  // todo: widths from button.js should be added here as well
  // #### padding & margin #### //
  paddingMed: {
    value: '2rem',
    dataType: 'dim'
  },
  mobileGutter: {
    value: '1.25rem',
    dataType: 'dim'
  },
  twoColSpacing: {
    value: '2.5rem',
    dataType: 'dim'
  },
  boldOverDarkSpacing: {
    value: '.07rem',
    dataType: 'dim'
  },
  modalPadding: {
    value: '3rem',
    dataType: 'dim'
  },
  infoPadding: {
    value: '.5rem',
    dataType: 'dim'
  },
  // ## BORDERS ## //
  standardButtonBorder: {
    value: '1px solid',
    dataType: 'other'
  },
  thinLine: {
    value: '1px',
    dataType: 'dim'
  },
  thickLine: {
    value: '3px',
    dataType: 'dim'
  },
  borderRadius: {
    value: '.3rem',
    dataType: 'dim'
  },
  borderRadiusWide: {
    value: '.6rem',
    dataType: 'dim'
  },
  borderRadiusButton: {
    value: '1.5rem',
    dataType: 'dim'
  },
  // ## Layout ## //
  mobilMinContent: {
    value: '20rem',
    dataType: 'dim'
  },
  smallBreak: {
    value: '48rem',
    dataType: 'dim'
  },
  // 768px - considered largest mobile width
  mediumBreak: {
    value: '64rem',
    dataType: 'dim'
  },
  // 1024px - largest tablet width (anything larger is desktop)
  maxWidth: {
    value: '80rem',
    dataType: 'dim'
  },
  // 1280px - not entirely sure this is needed...
  // ## Custom Component Sizes
  // ## BooleanListItem
  space: {
    value: '0.5rem',
    dataType: 'dim'
  },
  spaceBetweenCheckboxes: {
    value: '4rem',
    dataType: 'dim'
  },
  // ## In Styleguide Styling
  fullsizeComponentOffset: {
    value: '.25rem auto',
    dataType: 'other'
  },
  // ### component widths ###
  infoCellWidth: {
    value: '3rem',
    dataType: 'dim'
  },
  crudButtonWidth: {
    value: '5rem',
    dataType: 'dim'
  },
  topThirdHeightOffset: {
    value: '75%',
    dataType: 'dim'
  },
  cardMinimumHeight: {
    value: '5rem',
    dataType: 'dim'
  },
  cardTextPadding: {
    value: '0.3rem',
    dataType: 'dim'
  },
  sideNavWidth: {
    value: '8rem',
    dataType: 'dim'
  },
  subNavWidth: {
    value: '20rem',
    dataType: 'dim'
  },
  cardLeftContent: {
    value: '12rem',
    dataType: 'dim'
  },
  cardAside: {
    value: '20rem',
    dataType: 'dim'
  },
  component_small: {
    value: '15rem',
    dataType: 'dim'
  },
  // todo: this is a preliminary stab at things... new designs will require elements hat do not flow to 100% of parent width
  component_medium: {
    value: '25rem',
    dataType: 'dim'
  },
  // todo: this is a preliminary stab at things... new designs will require elements hat do not flow to 100% of parent width
  component_large: {
    value: '35rem',
    dataType: 'dim'
  },
  // todo: this is a preliminary stab at things... new designs will require elements hat do not flow to 100% of parent width
  // ### Animation ###
  noWaitAnimationDuration: {
    value: '200ms',
    dataType: 'time'
  },
  activeToggleOffset: {
    value: '.75rem',
    dataType: 'dim'
  },
  // For toggles that exist inline with other buttons. Prevents fat fingers
  // ### Responsive/Modular layout variables ### //
  breakpoints: {
    value: ['31.25rem', '64rem', '80rem'],
    dataType: 'other'
  }
});

var _default = cakeTheme;
exports.default = _default;